export const options = [
  {
    id: 0,
    icon: 'Property',
    category: 'Imóveis',
    items: [
      {
        id: 1,
        name: 'Casa',
      },
      {
        id: 2,
        name: 'Apartamento',
      },
      {
        id: 3,
        name: 'Sala comercial',
      },
      {
        id: 4,
        name: 'Terreno',
      },
      {
        id: 5,
        name: 'Construção',
      },
      {
        id: 6,
        name: 'Reforma',
      },
    ],
  },
  {
    id: 7,
    icon: 'Hatchback',
    category: 'Veículos',
    items: [
      {
        id: 8,
        name: 'Carro',
      },
      {
        id: 9,
        name: 'Moto',
      },
      {
        id: 10,
        name: 'Caminhão',
      },
      {
        id: 11,
        name: 'Aeronave',
      },
      {
        id: 12,
        name: 'Embarcação',
      },
    ],
  },
  {
    id: 13,
    icon: 'Plant',
    category: 'Agro',
    items: [
      {
        id: 14,
        name: 'Trator',
      },
      {
        id: 15,
        name: 'Pulverizador',
      },
      {
        id: 16,
        name: 'Colheitadeira',
      },
      {
        id: 17,
        name: 'Caminhão de transporte',
      },
      {
        id: 18,
        name: 'Plantadeira',
      },
      {
        id: 19,
        name: 'Silo',
      },
      {
        id: 20,
        name: 'Geradores',
      },
    ],
  },
  {
    id: 21,
    icon: 'Airplane',
    category: 'Serviços',
    items: [
      {
        id: 22,
        name: 'Estética',
      },
      {
        id: 23,
        name: 'Viagens',
      },
      {
        id: 24,
        name: 'Formatura',
      },
      {
        id: 25,
        name: 'Intercâmbio',
      },
    ],
  },
];
